import React from "react";
import BehaviourBarGraph from "../BehaviourBarGraph.jsx";
import { formatPercentage } from "@signolteam/shared/units-of-measure";

const defaultMetadata = {
  frac_trim_mode_green: 0.9,
};

export const behaviourMetadataFields = Object.keys(defaultMetadata);
export default function graph({
  unit = "%",
  metadata = defaultMetadata,
  missingDataMsg,
  bvrColour,
  isExample,
}) {
  const actual = Number(metadata["frac_trim_mode_green"]) * 100;
  const threshold = 50;

  if (isNaN(actual) || isNaN(threshold)) {
    return (
      <div className="relative text-center my-6 mx-auto text-2xl fill-current">
        {missingDataMsg}
      </div>
    );
  }

  const data = [
    {
      name: "Compliance with Eniram green range",
      mobileName: "Label",
      beforeThreshold: actual > threshold ? threshold : actual,
      afterThreshold: actual > threshold ? actual - threshold : 0,
      underThresholdColour:
        actual > threshold ? bvrColour.codes["500"] : bvrColour.codes["200"],
      overThresholdColour: bvrColour.codes["500"],
    },
  ];

  const domainMin = 0;
  const domainMax = 110;
  const domain = [domainMin, domainMax];

  const ticks = [];
  for (let i = domainMin + 1; i < domainMax / 10; i++) {
    ticks.push(i * 10);
  }

  const thresholdLineColour = bvrColour.codes["900"];

  return (
    <BehaviourBarGraph
      data={data}
      threshold={threshold}
      thresholdLabel={`Signol threshold (${threshold}%)`}
      mobileDomain={domain}
      domain={domain}
      refLineColour={thresholdLineColour}
      success={!(threshold < actual)}
      unitOfMeasure={unit}
      axisLabel={"Percentage of time (%)"}
      hideYLine={true}
      hideNum={true}
      barLabelFormatter={(value) =>
        `${formatPercentage("0-100", value, 0, { boundaryValues: [0, threshold] }).formattedValue}`
      }
      ticks={ticks}
      isExample={isExample}
    />
  );
}
